window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle');
    
} catch (e) {}

require('jquery-viewer');
require('bootstrap-notify');

require('blueimp-file-upload');

// import 'x-editable/dist/bootstrap-editable/js/bootstrap-editable.js';
